/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArenaScoringEventTargetRange
 */
export interface ArenaScoringEventTargetRange {
    /**
     * 
     * @type {number}
     * @memberof ArenaScoringEventTargetRange
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof ArenaScoringEventTargetRange
     */
    max?: number;
}

/**
 * Check if a given object implements the ArenaScoringEventTargetRange interface.
 */
export function instanceOfArenaScoringEventTargetRange(value: object): value is ArenaScoringEventTargetRange {
    return true;
}

export function ArenaScoringEventTargetRangeFromJSON(json: any): ArenaScoringEventTargetRange {
    return ArenaScoringEventTargetRangeFromJSONTyped(json, false);
}

export function ArenaScoringEventTargetRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArenaScoringEventTargetRange {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function ArenaScoringEventTargetRangeToJSON(json: any): ArenaScoringEventTargetRange {
    return ArenaScoringEventTargetRangeToJSONTyped(json, false);
}

export function ArenaScoringEventTargetRangeToJSONTyped(value?: ArenaScoringEventTargetRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

